import { render, staticRenderFns } from "./QComparisonChart.vue?vue&type=template&id=690ef8f3&scoped=true&"
import script from "./QComparisonChart.vue?vue&type=script&lang=js&"
export * from "./QComparisonChart.vue?vue&type=script&lang=js&"
import style0 from "./QComparisonChart.vue?vue&type=style&index=0&id=690ef8f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690ef8f3",
  null
  
)

export default component.exports